module.exports = __webpack_public_path__ + "img/5.f857f2fb.png";